module.exports = __webpack_public_path__ + "static/media/blog-details.fc664ed6.jpg";